import React, { useEffect, useMemo } from "react";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../navigations/RootNavigation";
import PdfAssetViewer from "../components/PdfAssetViewer";
import { useI18n } from "../hooks/i18n-hooks";
import MarkdownView from "../components/MarkdownView";
import VStack from "../ui_atoms/VStack";

type PdfViewerScreenProps = StackScreenProps<RootStackParamList, "PdfViewer">;

const PdfViewerScreen = ({ route, navigation }: PdfViewerScreenProps) => {
    const i18n = useI18n();
    const { title, filename, assetId, assetUrl, topMarkdown } = useMemo(
        () => route.params,
        [route.params],
    );
    useEffect(() => {
        navigation.setOptions({
            title: title || "",
        });
    }, [navigation, title]);

    return (
        <>
            {topMarkdown && (
                <VStack bottom="2/3" alignment="center">
                    <MarkdownView
                        markdown={topMarkdown.text}
                        markdownStyle={{
                            paragraph: {
                                textAlign: "center",
                                color: topMarkdown.color,
                            },
                            strong: {
                                textAlign: "center",
                                color: topMarkdown.color,
                            },
                        }}
                    />
                </VStack>
            )}
            <PdfAssetViewer
                assetId={assetId}
                assetUrl={assetUrl}
                filename={filename}
                waitingDescription={i18n.t("loading")}
                scrollEnabled={true}
            />
        </>
    );
};

export default PdfViewerScreen;
